export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // navigation
    const menuToggle = document.querySelector('[data-navigation-toggle]');
    const menu = document.querySelector('.navigation__menu');

    /* Toggle mobile menu */
    menuToggle.addEventListener('click', () => {
      if (menu.classList.contains('navigation--open')) {
        menu.classList.remove('navigation--open');
        document.querySelector('.NavToggle').classList.remove('NavToggle--close');
      } else {
        menu.classList.add('navigation--open');
        document.querySelector('.NavToggle').classList.add('NavToggle--close');
      }
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js